module.exports = "<div class=\"grid-noBottom\">\n  <div class=\"col\" ng-transclude=\"left\">\n  </div>\n  <!-- left END -->\n\n  <div class=\"col align-tb-right\" ng-transclude=\"right\">\n  </div>\n  <!-- right END -->\n</div>\n<!-- .grid END -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpHeaderTopBar/adpHeaderTopBar.html
// module id = 537
// module chunks = 0